var map = {
	"./banner": 10,
	"./banner.jpeg": 10,
	"./favicon": 9,
	"./favicon.png": 9,
	"./favicon.svg": 35,
	"./footer": 11,
	"./footer.jpg": 11,
	"./logo": 12,
	"./logo-email": 13,
	"./logo-email.png": 13,
	"./logo-simple": 14,
	"./logo-simple.svg": 14,
	"./logo.svg": 12,
	"./logos/mastercard": 15,
	"./logos/mastercard.svg": 15,
	"./logos/post": 16,
	"./logos/post.svg": 16,
	"./logos/twint": 17,
	"./logos/twint.svg": 17,
	"./logos/visa": 18,
	"./logos/visa.svg": 18,
	"./missing-product-image": 19,
	"./missing-product-image.svg": 19,
	"./x": 20,
	"./x.svg": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;